import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./LocationCell.module.scss";
import { getStateAbbreviation } from "@/frontend/shared/lib/getStateAbbreviation/getStateAbbreviation";
import { TTableCompany } from "@/frontend/features/Company/model/types/types";

export function LocationCell({ field }: { field: TTableCompany }) {
  const { city, country, state } = field;

  return (
    <div className={styles.locationCell}>
      <div className={styles.location}>
        {city && (
          <Typography variant={"label-4"} color="greyscale900">
            {city},
          </Typography>
        )}
        {state && getStateAbbreviation(state) && (
          <Typography variant={"label-4"} color="greyscale900">
            {getStateAbbreviation(state, " ")},
          </Typography>
        )}
      </div>
      <Typography variant={"label-4"} color="greyscale900">
        {country}
      </Typography>
    </div>
  );
}
